"use strict";

import angular from "angular";

import _ from "lodash";

class ViewShareDialogCtrl {
    constructor($mdDialog, locals, DSNDialogService) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.data = locals.data;
        this.DSNDialogService = DSNDialogService;

        this.table = [];
    }

    $onInit() {
        this.mountTable();
    }

    getInteractionWithoutNull(action) {
        const peopleActionArr = _.get(
            this.locals.interactions.peopleByAction,
            `${action}`,
            []
        );

        return peopleActionArr.filter((s) => s);
    }

    mountTable() {
        const sharedFiltered = this.getInteractionWithoutNull("shared");

        const visualizedFiltered = this.getInteractionWithoutNull("visualized");

        const commentedFiltered = this.getInteractionWithoutNull("commented");

        const lengths = [
            sharedFiltered.length,
            visualizedFiltered.length,
            commentedFiltered.length
        ];

        const maxLength = Math.max(...lengths);

        for (let index = 0; index < maxLength; index++) {
            const sharedName = _.get(sharedFiltered, `[${index}].name`, "N/A");

            const visualizedName = _.get(
                visualizedFiltered,
                `[${index}].name`,
                "N/A"
            );

            const commentedName = _.get(
                commentedFiltered,
                `[${index}].name`,
                "N/A"
            );

            this.table.push({
                shared: sharedName,
                visualized: visualizedName,
                commented: commentedName
            });
        }
    }

    onClickComment(index) {
        const commented = this.locals.interactions.peopleByAction.commented[
            index
        ];
        if (!commented) return;

        this.$mdDialog.hide({ commented });
    }
}
angular
    .module("nucont.shared")
    .controller("ViewShareDialogCtrl", [
        "$mdDialog",
        "locals",
        "DSNDialogService",
        ViewShareDialogCtrl
    ]);
